var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketsegmentdrilldown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "market-segment 1",
    clipPath: "url(#clip0_206_4069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 3.05695V20.9431",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.9438 12H3.05762",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 12,
    cy: 12,
    r: 9.5,
    stroke: "#202842"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.50488 9.76424L8.5795 6.94279C8.60145 6.88909 8.67746 6.889 8.6995 6.94265L9.76433 9.76424",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.83984 9.06158H9.43446",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.7261 7.56093C15.7261 7.92462 15.4313 8.21944 15.0676 8.21944C14.8873 8.21944 14.2363 8.22236 14.2363 8.22236V6.90247C14.2363 6.90247 14.8545 6.90247 15.0676 6.90247C15.4313 6.90242 15.7261 7.19724 15.7261 7.56093Z",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.9831 8.9905C15.9831 9.41594 15.6382 9.76082 15.2128 9.76082C15.0018 9.76082 14.2363 9.76423 14.2363 9.76423V8.22021C14.2363 8.22021 14.9635 8.22021 15.2128 8.22021C15.6383 8.22017 15.9831 8.56505 15.9831 8.9905Z",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M9.66356 14.4802C9.43519 14.3259 9.1599 14.2358 8.86353 14.2358C8.07329 14.2358 7.43262 14.8764 7.43262 15.6666C7.43262 16.4569 8.07324 17.0976 8.86353 17.0976C9.18446 17.0976 9.44847 16.9919 9.64886 16.8135C9.69034 16.7765 9.72903 16.7365 9.76502 16.6936",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M1 1H3.32519",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M3.32519 2.43091H1",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M1 3.86176H4.2195L6.72454 6.3668",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M23.001 1H20.6758",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M20.6758 2.43091H23.001",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M23.0009 3.86176H19.7814L17.2764 6.3668",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M1 23H3.32519",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M3.32519 21.5691H1",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M1 20.1382H4.2195L6.7245 17.6332",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_4069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketsegmentdrilldown);
export default __webpack_public_path__ + "static/media/marketsegmentdrilldown.58802f3a6018d5f305c39313ae7ea7b4.svg";
export { ForwardRef as ReactComponent };